import { Component } from '@angular/core';

@Component({
  selector: 'app-prient-header',
  templateUrl: './prient-header.component.html',
  styleUrls: ['./prient-header.component.css']
})
export class PrientHeaderComponent {
dentalBusinessAreaId = localStorage.getItem('dentalBusinessAreaId')
}
